export default {
  licensePlate: 'Nummerntafel',
  notification: {
    save: {
      type: 'success',
      message: 'LKW gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    delete: {
      type: 'success',
      message: 'LKW gelöscht',
      title: 'Erfolgreich gelöscht'
    }
  }
}
